import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=4ca5b9ad"
import script from "./Unit.vue?vue&type=script&setup=true&lang=js"
export * from "./Unit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports